import { Injectable, inject } from '@angular/core';
import { CanActivateChildFn, Router } from '@angular/router';
import { AuthenticationService } from './authentication.service';
import { PermissionType } from '@app-types/enums/permission-type';
import { PermissionService } from '../permission/permission.service';
import { MatchError } from '../errors/error-matcher';
import { LoggingHandler } from '../errors/logging.service';
import { Permissions } from './auth.guard';
import { ROUTES } from '@app-shared/constants/routes/fe.routes';

const { ERRORS } = ROUTES;
const { FORBIDDEN } = ERRORS;

@Injectable({
  providedIn: 'root',
})
export class RootPermissionsService extends Permissions {
  constructor(
    router: Router,
    authenticationService: AuthenticationService,
    private permissionService: PermissionService,
    matchError: MatchError,
    loggingHandler: LoggingHandler
  ) {
    super(router, authenticationService, matchError, loggingHandler);
  }

  override async canActivate(): Promise<boolean> {
    const superActivationResult = await super.canActivate();

    if (!superActivationResult) {
      return false;
    } else {
      const hasPermissionOver = await this.permissionService.hasPermissionOver(
        null,
        null,
        PermissionType.CanEverything
      );

      return hasPermissionOver
        ? hasPermissionOver
        : this.router.navigateByUrl(`/${FORBIDDEN}`);
    }
  }
}

export const RootAuthGuard: CanActivateChildFn = (): Promise<boolean> => {
  return inject(RootPermissionsService).canActivate();
};
